<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 48 48" :class="[`${prefix}-icon`, `${prefix}-icon-Refresh`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_694fc5efa9__a"><rect width="48" height="48" rx="0"/></clipPath></defs><g clip-path="url(#svg_694fc5efa9__a)"><path d="M39.8583,19.078400000000002L32.7468,19.078400000000002C31.8394,19.078400000000002,31.1051,18.343899999999998,31.1051,17.4364C31.1051,16.5289,31.8394,15.7945,32.7468,15.7945L35.6041,15.7945C33.0296,12.15605,28.7965,9.77967,23.9979,9.77967C16.14368,9.77967,9.77927,16.144840000000002,9.77927,24C9.77927,31.8552,16.14368,38.2203,23.9979,38.2203C31.8479,38.2203,38.216499999999996,31.8552,38.216499999999996,24C38.216499999999996,23.0925,38.9509,22.3581,39.8583,22.3581C40.7656,22.3581,41.5,23.0925,41.5,24C41.5,33.6659,33.6627,41.5,23.9979,41.5C14.33311,41.5,6.5,33.6659,6.5,24C6.5,14.334060000000001,14.33311,6.5,23.9979,6.5C29.8643,6.5,35.042699999999996,9.39134,38.216499999999996,13.823319999999999L38.216499999999996,10.87711C38.216499999999996,9.96961,38.9509,9.23517,39.8583,9.23517C40.7656,9.23517,41.5,9.96961,41.5,10.87711L41.5,17.4407C41.5,18.343899999999998,40.7614,19.078400000000002,39.8583,19.078400000000002Z"/></g></svg>
</template>
<script>

export default {
  name: 'IconRefresh',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
